import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TeacherHeader from "../common/TeacherHeader";
import Footer from "../common/Footer";
import { baseUrl } from "../../Utility/constants";
import { ReportCardEndpoints } from "../../Utility/Endpoints";
import { getSchoolId, getCurrentSession } from "../../Utility/commonFunctions";
import jsPDF from "jspdf";
import { useRef } from "react";
import html2canvas from "html2canvas";

const CategoryWiseAnnualExamReport = () => {
    const reportRef = useRef(null);
    const [report, setReport] = useState(null);
    const [school, setSchool] = useState(null);
    const [loading, setLoading] = useState(true);
    const [sessionDetails, setSessionDetails] = useState("");
    const [teacherData, setTeacherDData] = useState({});
    const [isPdfExport, setIsPdfExport] = useState(false);

    useEffect(() => {
        fetchReport();
    }, []);

    const fetchReport = async () => {
        try {
            setLoading(true);

            const teacherId = localStorage.getItem("userID");

            // Teacher Details
            const url = `${baseUrl}/api/Teachers/GetTeacherDetailsByTeacherId?teacherId=${teacherId}`;
            const teacherResponse = await axios.get(url);
            if (
                teacherResponse &&
                teacherResponse.data &&
                teacherResponse.data.length > 0
            ) {
                setTeacherDData(teacherResponse?.data?.[0]);
            }
            else {
                setTeacherDData([]);
            }

            // Overall Annual Report API
            const reportResponse = await axios.get(
                `${ReportCardEndpoints.CategoryWiseAnnualExamReportByTeacherId}?teacherId=${teacherId}`
            );

            // School Information
            const schoolId = await getSchoolId();

            const schoolResponse = await axios.get(
                `${baseUrl}/api/SchoolGeneralInfo/GetSchoolInfo?schoolId=${schoolId}`
            );

            // Fetch current session name
            const sessionName = await getCurrentSession();

            setSessionDetails(sessionName);
            setReport(reportResponse.data);
            setSchool(schoolResponse.data);
        } catch (error) {
            console.error(error);
            toast.error("Failed to load Overall Annual Exam Report.");
        } finally {
            setLoading(false);
        }
    };
    const exportToPDF = async () => {
        try {
            if (!reportRef.current) {
                toast.error("Report is not ready yet.");
                return;
            }


            // Change vertical text style for PDF
            setIsPdfExport(true);

            // Wait for React to update DOM
            await new Promise(resolve => setTimeout(resolve, 200));

            const reportElement = reportRef.current;

            // Table container (horizontal scroll div)
            const tableContainer = reportElement.querySelector(".table-responsive");

            // Save scroll position
            const currentScrollLeft = tableContainer ? tableContainer.scrollLeft : 0;

            // Move table to start before capture
            if (tableContainer) {
                tableContainer.scrollLeft = 0;
            }

            // Save original values
            const originalScrollLeft = tableContainer.scrollLeft;
            const originalPaddingRight = tableContainer.style.paddingRight;

            // Move table to beginning
            tableContainer.scrollLeft = 0;

            // Add extra space so html2canvas captures the last column
            tableContainer.style.paddingRight = "30px";

            const canvas = await html2canvas(reportElement, {
                scale: 3,
                useCORS: true,
                backgroundColor: "#FFFFFF",
                scrollX: 0,
                scrollY: 0,

                width: reportElement.scrollWidth + 45,
                height: reportElement.scrollHeight,

                windowWidth: reportElement.scrollWidth + 45,
                windowHeight: reportElement.scrollHeight,
            });

            // Restore scroll position
            if (tableContainer) {
                tableContainer.scrollLeft = currentScrollLeft;
                tableContainer.style.paddingRight = originalPaddingRight;
            }

            const imgData = canvas.toDataURL("image/png");

            const pdf = new jsPDF({
                orientation: "landscape",
                unit: "mm",
                format: "a3",
            });

            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();

            const imgWidth = pageWidth;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            let heightLeft = imgHeight;
            let position = 0;

            pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight, "", "FAST");

            heightLeft -= pageHeight;

            while (heightLeft > 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();

                pdf.addImage(
                    imgData,
                    "PNG",
                    0,
                    position,
                    imgWidth,
                    imgHeight,
                    "",
                    "FAST"
                );

                heightLeft -= pageHeight;
            }

            pdf.save(
                `Categorywise_Annual_Result_Class_${teacherData?.classSubjectDetails?.[0]?.class || ""}_${sessionDetails}.pdf`
            );

            toast.success("PDF exported successfully.");
        } catch (error) {
            console.error(error);
            toast.error("Failed to export PDF.");
        } finally {
            setIsPdfExport(false);
        }
    };

    return (
        <>
            <TeacherHeader />

            <div className="container my-4">
                <div className="d-flex justify-content-end mb-3">
                    <button className="btn btn-danger"
                        onClick={exportToPDF}
                    >
                        <i className="bi bi-file-earmark-pdf-fill me-2"></i>
                        Export PDF
                    </button>
                </div>

                {loading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary"></div>
                    </div>
                ) : (
                    <div style={{ overflowX: "auto" }}>
                        <div
                            ref={reportRef}
                            className="bg-white border border-dark p-4"
                            style={{
                                width: "1685px",          // was 1650px
                                minWidth: "1685px",
                                paddingRight: isPdfExport ? "35px" : "20px", // IMPORTANT
                                background: "#fff",
                                fontFamily: "Times New Roman, serif",
                                color: "#000",
                            }}
                        >

                            {/* =======================================================
                                SCHOOL HEADER (Same as Leaving Certificate)
                        ======================================================== */}

                            <table className="table table-bordered border-dark mb-0">
                                <tbody>
                                    <tr>

                                        {/* School Logo */}

                                        <td
                                            style={{
                                                width: "140px",
                                                textAlign: "center",
                                                verticalAlign: "middle"
                                            }}
                                        >
                                            <img
                                                id="schoolLogo"
                                                src={school?.logo}
                                                alt="School Logo"
                                                crossOrigin="anonymous"
                                                style={{
                                                    width: "100px",
                                                    height: "100px",
                                                    objectFit: "contain",
                                                }}
                                            />
                                        </td>

                                        {/* School Details */}

                                        <td
                                            className="text-center border-start-0 border-end-0"
                                            style={{ verticalAlign: "middle" }}
                                        >
                                            <h6 className="mb-1 fw-bold">
                                                {school?.organizationName}
                                            </h6>

                                            <h3 className="fw-bold mb-1 text-uppercase">
                                                {school?.schoolOrCollegeName}
                                            </h3>

                                            <div className="fw-semibold mb-1">
                                                (Affiliated to H.S.C. Board, Govt. of Maharashtra)
                                            </div>

                                            <div className="small">
                                                Address : {school?.address}
                                            </div>

                                            <div className="small">
                                                Phone :{" "}
                                                <strong>{school?.schoolOrCollegeContactNo}</strong>
                                                {" | "}
                                                Website :{" "}
                                                <strong>{school?.schoolWebsiteName}</strong>
                                            </div>

                                            <div className="small">
                                                Email : <strong>{school?.email}</strong>
                                            </div>

                                            <div className="small">
                                                U-DISE No : <strong>{school?.udiseNo}</strong>

                                                {(school?.ssC10thIndexNo ||
                                                    school?.hsC12thIndexNo) && (
                                                        <>
                                                            {" | "}Index No :{" "}
                                                            <strong>
                                                                {school?.ssC10thIndexNo}
                                                                {school?.ssC10thIndexNo &&
                                                                    school?.hsC12thIndexNo &&
                                                                    " | "}
                                                                {school?.hsC12thIndexNo}
                                                            </strong>
                                                        </>
                                                    )}
                                            </div>
                                        </td>

                                        {/* Empty Cell 

                                    <td style={{ width: "140px" }}></td>*/}

                                    </tr>
                                </tbody>
                            </table>


                            {/* =======================================================
                                    REPORT TITLE
                        ======================================================== */}

                            <div className="text-center mb-3">

                                <h5 className="fw-bold">
                                    Categorywise Result of Annual Exam ({sessionDetails})
                                </h5>
                            </div>

                            {/* =======================================================
                                CLASS DETAILS
                        ======================================================== */}

                            <div className="row fw-bold mb-3">
                                <div className="col-8">
                                    Class :- {teacherData?.classSubjectDetails?.[0]?.class}
                                    {"   "}
                                    Division :- {teacherData?.classSubjectDetails?.[0]?.section}
                                </div>

                                <div className="col-4 text-end">
                                    Class Teacher :- {teacherData?.fullName}
                                </div>
                            </div>

                            {/* =======================================================
                        CATEGORYWISE RESULT TABLE (Page 13 PDF)
                        ======================================================= */}

                            <div
                                className="table-responsive mb-3"
                                style={{
                                    overflowX: "auto",
                                    overflowY: "hidden",
                                    border: "2px solid black"
                                }}
                            >
                                <table
                                    className="table table-bordered text-center align-middle mb-0"
                                    style={{
                                        borderCollapse: "collapse",
                                        tableLayout: "fixed",
                                        minWidth: "1650px",      // Gives proper space like PDF
                                        fontSize: "12px"
                                    }}
                                >
                                    <thead>
                                        {/* Header Row 1 */}
                                        <tr>
                                            <th
                                                rowSpan={2}
                                                style={{
                                                    border: "2px solid black",
                                                    width: "70px",
                                                    minWidth: "70px",
                                                    padding: 0,
                                                    position: "relative",
                                                    verticalAlign: "middle",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        inset: 0,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        fontWeight: "bold",
                                                        background: "#fff",
                                                        zIndex: 10,
                                                    }}
                                                >
                                                    Sr. No.
                                                </div>
                                            </th>

                                            <th
                                                rowSpan={2}
                                                style={{
                                                    border: "2px solid black",
                                                    width: "90px",
                                                    minWidth: "90px",
                                                    padding: 0,
                                                    position: "relative",
                                                    verticalAlign: "middle",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        inset: 0,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        fontWeight: "bold",
                                                        background: "#fff",
                                                        zIndex: 10,
                                                    }}
                                                >
                                                    Category
                                                </div>
                                            </th>

                                            {[
                                                "Passed Students",
                                                "Promoted",
                                                "Total Passed Students",
                                                "Absent",
                                                "Failed Students",
                                                "Total Students"
                                            ].map((title) => (
                                                <th
                                                    key={title}
                                                    rowSpan={2}
                                                    style={{
                                                        border: "2px solid black",
                                                        width: "46px",
                                                        minWidth: "46px",
                                                        height: "140px",
                                                        padding: 0,
                                                        position: "relative",
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: "50%",
                                                            top: "50%",
                                                            whiteSpace: "nowrap",
                                                            fontWeight: "bold",
                                                            fontSize: "12px",

                                                            // UI
                                                            transform: isPdfExport
                                                                ? "translate(-50%, -50%) rotate(-90deg)"
                                                                : "translate(-50%, -50%) rotate(90deg)",

                                                            transformOrigin: "center center",
                                                        }}
                                                    >
                                                        {title}
                                                    </div>
                                                </th>
                                            ))}

                                            <th colSpan="3" style={{ border: "2px solid black" }}>
                                                Above 90%
                                            </th>

                                            <th colSpan="3" style={{ border: "2px solid black" }}>
                                                80% To 89%
                                            </th>

                                            <th colSpan="3" style={{ border: "2px solid black" }}>
                                                70% To 79%
                                            </th>

                                            <th colSpan="3" style={{ border: "2px solid black" }}>
                                                60% To 69%
                                            </th>

                                            <th colSpan="3" style={{ border: "2px solid black" }}>
                                                50% To 59%
                                            </th>

                                            <th colSpan="3" style={{ border: "2px solid black" }}>
                                                40% To 49%
                                            </th>

                                            <th colSpan="3" style={{ border: "2px solid black" }}>
                                                35% To 39%
                                            </th>
                                        </tr>

                                        {/* Header Row 2 */}
                                        <tr>
                                            {Array.from({ length: 7 }).map((_, index) => (
                                                <React.Fragment key={index}>
                                                    <th style={{ border: "2px solid black", minWidth: "42px", width: "42px" }}>
                                                        Male
                                                    </th>

                                                    <th style={{ border: "2px solid black", minWidth: "42px", width: "42px" }}>
                                                        Female
                                                    </th>

                                                    {/* Last Total column gets extra width */}
                                                    <th
                                                        style={{
                                                            border: "2px solid black",
                                                            minWidth: index === 6 ? "58px" : "42px",
                                                            width: index === 6 ? "58px" : "42px",
                                                            paddingLeft: index === 6 ? "4px" : 0,
                                                            paddingRight: index === 6 ? "4px" : 0,
                                                            textAlign: "left",
                                                        }}
                                                    >
                                                        Total
                                                    </th>
                                                </React.Fragment>
                                            ))}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {report?.categories?.map((cat, index) => (
                                            <tr key={cat.category}>
                                                <td style={{ border: "2px solid black" }}>{index + 1}</td>
                                                <td style={{ border: "2px solid black" }}>{cat.category}</td>

                                                <td style={{ border: "2px solid black" }}>{cat.passedStudents}</td>
                                                <td style={{ border: "2px solid black" }}>{cat.promoted}</td>
                                                <td style={{ border: "2px solid black" }}>{cat.totalPassedStudents}</td>
                                                <td style={{ border: "2px solid black" }}>{cat.absent}</td>
                                                <td style={{ border: "2px solid black" }}>{cat.failedStudents}</td>
                                                <td style={{ border: "2px solid black" }}>{cat.totalStudents}</td>

                                                {/* Above 90 */}
                                                <td style={{ border: "2px solid black" }}>{cat.above90.male}</td>
                                                <td style={{ border: "2px solid black" }}>{cat.above90.female}</td>
                                                <td style={{ border: "2px solid black" }}>{cat.above90.total}</td>

                                                {/* 80-89 */}
                                                <td style={{ border: "2px solid black" }}>{cat.between80To89.male}</td>
                                                <td style={{ border: "2px solid black" }}>{cat.between80To89.female}</td>
                                                <td style={{ border: "2px solid black" }}>{cat.between80To89.total}</td>

                                                {/* 70-79 */}
                                                <td style={{ border: "2px solid black" }}>{cat.between70To79.male}</td>
                                                <td style={{ border: "2px solid black" }}>{cat.between70To79.female}</td>
                                                <td style={{ border: "2px solid black" }}>{cat.between70To79.total}</td>

                                                {/* 60-69 */}
                                                <td style={{ border: "2px solid black" }}>{cat.between60To69.male}</td>
                                                <td style={{ border: "2px solid black" }}>{cat.between60To69.female}</td>
                                                <td style={{ border: "2px solid black" }}>{cat.between60To69.total}</td>

                                                {/* 50-59 */}
                                                <td style={{ border: "2px solid black" }}>{cat.between50To59.male}</td>
                                                <td style={{ border: "2px solid black" }}>{cat.between50To59.female}</td>
                                                <td style={{ border: "2px solid black" }}>{cat.between50To59.total}</td>

                                                {/* 40-49 */}
                                                <td style={{ border: "2px solid black" }}>{cat.between40To49.male}</td>
                                                <td style={{ border: "2px solid black" }}>{cat.between40To49.female}</td>
                                                <td style={{ border: "2px solid black" }}>{cat.between40To49.total}</td>

                                                {/* 35% To 39% */}
                                                <td style={{ border: "2px solid black", width: "42px" }}>
                                                    {cat.between35To39.male}
                                                </td>

                                                <td style={{ border: "2px solid black", width: "42px" }}>
                                                    {cat.between35To39.female}
                                                </td>

                                                <td
                                                    style={{
                                                        border: "2px solid black",
                                                        width: "58px",
                                                        minWidth: "58px",
                                                        paddingLeft: "4px",
                                                        paddingRight: "4px",
                                                    }}
                                                >
                                                    {cat.between35To39.total}
                                                </td>
                                            </tr>
                                        ))}

                                        {/* Grand Total Row */}
                                        <tr className="fw-bold">
                                            <td
                                                colSpan={2}
                                                style={{
                                                    border: "2px solid black",
                                                    whiteSpace: "nowrap"
                                                }}
                                            >
                                                Grand Total
                                            </td>

                                            <td style={{ border: "2px solid black" }}>{report?.grandTotal?.passedStudents}</td>
                                            <td style={{ border: "2px solid black" }}>{report?.grandTotal?.promoted}</td>
                                            <td style={{ border: "2px solid black" }}>{report?.grandTotal?.totalPassedStudents}</td>
                                            <td style={{ border: "2px solid black" }}>{report?.grandTotal?.absent}</td>
                                            <td style={{ border: "2px solid black" }}>{report?.grandTotal?.failedStudents}</td>
                                            <td style={{ border: "2px solid black" }}>{report?.grandTotal?.totalStudents}</td>

                                            {[
                                                report?.grandTotal?.above90,
                                                report?.grandTotal?.between80To89,
                                                report?.grandTotal?.between70To79,
                                                report?.grandTotal?.between60To69,
                                                report?.grandTotal?.between50To59,
                                                report?.grandTotal?.between40To49,
                                                report?.grandTotal?.between35To39
                                            ].map((range, index) => (
                                                <React.Fragment key={index}>
                                                    <td style={{ border: "2px solid black" }}>{range?.male}</td>
                                                    <td style={{ border: "2px solid black" }}>{range?.female}</td>
                                                    <td style={{ border: "2px solid black" }}>{range?.total}</td>
                                                </React.Fragment>
                                            ))}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="small fw-semibold mt-1">
                                * Filled By Class Teacher
                            </div>

                            {/* =======================================================
                                SIGNATURES
                        ======================================================== */}

                            <div className="row text-center">

                                <div className="col-3">
                                    <div style={{ height: "50px" }}></div>
                                    <div className="fw-semibold">Checked By</div>
                                </div>

                                <div className="col-3">
                                    <div style={{ height: "50px" }}></div>
                                    <div>Class Teacher</div>
                                </div>

                                <div className="col-3">
                                    <div style={{ height: "50px" }}></div>
                                    <div className="fw-semibold">Vice-Principal</div>
                                </div>

                                <div className="col-3">
                                    <div style={{ height: "50px" }}></div>
                                    <div className="fw-semibold">Principal</div>
                                </div>

                            </div>

                        </div>
                    </div>
                )}

            </div>

            <ToastContainer position="top-right" autoClose={3000} />
            <Footer />
        </>
    );
};

export default CategoryWiseAnnualExamReport;